import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { arreglosTestimonials } from '../../../mocks/testimonios';

export default function ArreglosTestimonials() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.05, distance: 36, duration: 900 });

  return (
    <section ref={ref} className="w-full bg-brand-cream py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="text-center max-w-2xl mx-auto mb-14" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Prêt-à-porter & Arreglos
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
            Confianza del <span className="italic text-brand-gray-300">día a día</span>
          </h2>
          <p className="font-sans text-brand-gray-500 text-base leading-[1.8] mt-5">
            Vecinos de Barcelona y clientes recurrentes que confían en nuestro taller
            para mantener su armario impecable con arreglos profesionales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {arreglosTestimonials.map((t, index) => (
            <div
              key={t.id}
              className="bg-white rounded-3xl p-6 md:p-8"
              style={isVisible ? {
                opacity: 1,
                transform: 'translateY(0px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 100}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 100}ms`,
              } : {
                opacity: 0,
                transform: 'translateY(36px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 100}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 100}ms`,
                willChange: 'opacity, transform',
              }}
            >
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-brand-black text-sm" />
                ))}
              </div>

              <p className="font-sans text-brand-gray-600 text-[15px] leading-[1.7]">
                &ldquo;{t.text}&rdquo;
              </p>

              <div className="mt-6 pt-5 border-t border-brand-gray-100">
                <p className="font-sans text-brand-black text-sm font-medium">
                  {t.name}
                </p>
                <div className="flex items-center justify-between mt-1">
                  <p className="font-sans text-brand-gray-400 text-xs">
                    {t.location}
                  </p>
                  <span className="font-sans text-brand-gray-400 text-[10px] tracking-wider uppercase">
                    {t.service}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}